import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import SelectField from '../SelectField';
import SideMenu from '../SideMenu';
import EmptyState from '../../../../../../components/EmptyState';
import Button from '../../../../../../components/Button';
import SubHeader from '../../../../../../components/SubHeader';
import LoadMask from '../../../../../../components/LoadMask';
import './styles.css';
import { changeStep, nextStep, getDrivers, getVehicles, selectDriver, selectVehicle } from '../../../../../../redux/new-schedule';
import { getDriversUI, getVehiclesUI } from '../../../../../../redux/selectors';
class DriverSelection extends Component {
  componentDidMount = () => {
    if (this.props.currentStep !== 3) this.props.dispatch(changeStep(this.props.currentStep));
    if (this.props.drivers.length === 0) this.props.dispatch(getDrivers());
    if (this.props.vehicles.length === 0) this.props.dispatch(getVehicles());
  }
  _onSelected = (item, type) => {
    if (type === "driver") {
      this.props.dispatch(selectDriver(item, this.props.currentType));
    }
    if (type === "vehicle") {
      this.props.dispatch(selectVehicle(item, this.props.currentType));
    }
  };
  _nextStep = () => {
    if (!_.isEmpty(this.props.selectedDriver) && !_.isEmpty(this.props.selectedVehicle)) {
      this.props.dispatch(nextStep(4));
    }
  }
  render() {
    const { match, history, drivers, selectedDriver, vehicles, selectedVehicle, uiDrivers, uiVehicles } = this.props;
    return (
      <div className="DriverSelection">
        <SubHeader
          title="Agendar"
          renderSide={() => (<SideMenu match={match} history={history} />)}
        />
        {
          (drivers.length > 0 && !uiDrivers.isFetching && !uiDrivers.error) &&
          <div className="">
            <div className="DriverSelection__wrapper">
              <div className="DriverSelection__choice DriverSelection__choice--left" >
                <span className="DriverSelection__title">Selecione o motorista</span>
                <SelectField options={drivers} selected={selectedDriver} onSelected={this._onSelected} type="driver" />
              </div>
              {
                (vehicles.length > 0 && !uiVehicles.isFetching && !uiVehicles.error) ?
                  <div className="DriverSelection__choice" >
                    <span className="DriverSelection__title">Selecione o veículo</span>
                    <SelectField options={vehicles} selected={selectedVehicle} onSelected={this._onSelected} type="vehicle" disabled={_.isEmpty(selectedDriver)} />
                  </div>
                  :
                  <EmptyState
                    className="DriverSelection__empty-vehicles"
                    message="Não existem veículos disponíveis."
                  />
              }
            </div>
            <div className="DriverSelection__wrapper DriverSelection__wrapper-button">
              <Button text="Prosseguir" skin="primary" className="DriverSelection__button" onClick={this._nextStep} disabled={_.isEmpty(selectedDriver) || _.isEmpty(selectedVehicle)} />
            </div>
          </div>
        }
        {
          (drivers.length === 0 && !uiDrivers.isFetching && !uiDrivers.error) &&
          <EmptyState
            className="DriverSelection__empty-drivers"
            message="Não existem motoristas disponíveis."
          />
        }

        {
          (uiDrivers.isFetching || uiVehicles.isFetching) &&
          <LoadMask text="Carregando..." />
        }
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  currentStep: state.newSchedule.currentStep,
  availableStep: state.newSchedule.availableStep,
  drivers: state.newSchedule.drivers.list,
  vehicles: state.newSchedule.vehicles.list,
  currentType: state.newSchedule.currentType,
  selectedDriver: state.newSchedule.currentType === 0 ? state.newSchedule.loadSchedule.selectedDriver : state.newSchedule.unloadSchedule.selectedDriver,
  selectedVehicle: state.newSchedule.currentType === 0 ? state.newSchedule.loadSchedule.selectedVehicle : state.newSchedule.unloadSchedule.selectedVehicle,
  uiDrivers: getDriversUI(state),
  uiVehicles: getVehiclesUI(state),

})
export default connect(mapStateToProps)(DriverSelection);
